import React from 'react';
import styles from './styles.module.scss';

export default function ToggleSwitch({ isDisabled, state, setState }) {
  const handleChange = (e) => {
    setState(e.target.checked);
  };

  return (
    <label className={styles.toggleSwitch} style={{ opacity: isDisabled ? 0.3 : false }}>
      <input
        disabled={isDisabled}
        type="checkbox"
        className={styles.checkbox}
        checked={state}
        onChange={handleChange}
      />
      <span className={styles.slider}></span>
    </label>
  );
}